/**
 * 全局反馈抽屉
 * @module store/modules/globalFeedbackDrawer
 * @see module:store/modules/globalFeedbackDrawer
 * @example
 */
export default {
  namespaced: true,
  state: {
    // 是否显示抽屉
    visible: false,
    // 组件props数据
    propsData: {},
    // 组件事件监听器
    listeners: {}
  },
  getters: {},
  mutations: {
    // 显示抽屉
    showDrawer(state, payload = {}) {
      const { listeners = {}, ...propsData } = payload;
      state.visible = true;
      state.propsData = propsData;
      state.listeners = listeners;
    },
    // 隐藏抽屉
    hideDrawer(state) {
      state.visible = false;
      state.propsData = {};
      state.listeners = {};
    }
  },
  actions: {}
};
